import { useState, useEffect } from "react"
import { getDatabase, ref as dbRef, set as dbSet, push, get } from "firebase/database"
import { getAuth } from "firebase/auth"
import { Link, useLocation, useNavigate } from "react-router-dom"
import "./MachineryOrderForm.css"
import { db, set } from "../Firebase/firebase-config"

const MachineryOrderForm = () => {
    const location = useLocation()
    const product = location.state?.product || {}
    const [siteAddress, setSiteAddress] = useState("")
    const [selectedMachinery, setSelectedMachinery] = useState("");
    const [selectedCondition, setSelectedCondition] = useState("");
    const [selectedColour, setSelectedColour] = useState("");
    const [paymentOptionList] = useState(["EMI", "Full Payment"]);
    const [selectedPaymentOption, setSelectedPaymentOption] = useState("");
    const [siteAddressError, setSiteAddressError] = useState("")
    const [technicalSpecification, setTechnicalSpecification] = useState("")
    const [deliveryDate, setDeliveryDate] = useState("")
    const [userId, setUserId] = useState(null)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState("")
    const [contactPersonName, setContactPersonName] = useState("");
    const [contactPhoneNumber, setContactPhoneNumber] = useState("");
    const [contactEmail, setContactEmail] = useState("");
    const [success, setSuccess] = useState(false)
    const [uploadProgress, setUploadProgress] = useState({ po: 0, payment: 0 })
    const [companyName, setCompanyName] = useState("")
    const [showConfirmation, setShowConfirmation] = useState(false)
    const [apiKey,] = useState('');
    const [campaignName,] = useState('Altrange');
    const [destination,] = useState('+919592080108');
    const [userName,] = useState('');
    const [source,] = useState('');
    const [mediaUrl,] = useState('');
    const [mediaFilename,] = useState('');
    const [templateParams,] = useState([]);
    const [tags,] = useState([]);
    const [response, setResponse] = useState({});
    const navigate = useNavigate();
    const gifUrl = "/Images/New notification.gif"
    const [specs, setSpecs] = useState({});
    const machinerySpecs = {
        "JCB Backhoe Loader": [
            { label: "Engine Power (HP)", key: "enginePower", placeholder: "e.g. 92" },
            { label: "Bucket Capacity (m³)", key: "bucketCapacity", placeholder: "e.g. 0.26" },
            { label: "Operating Weight (tons)", key: "operatingWeight", placeholder: "e.g. 8.5" },
        ],
        "Tractor": [
            { label: "Engine Power (HP)", key: "enginePower", placeholder: "e.g. 55" },
            { label: "PTO Power (HP)", key: "ptoPower", placeholder: "e.g. 45" },
            { label: "Transmission Type", key: "transmissionType", placeholder: "e.g. Manual" },
            { label: "Weight (kg)", key: "weight", placeholder: "e.g. 2100" },
        ],
        "Hydraulic Jack": [
            { label: "Lifting Capacity (tons)", key: "liftingCapacity", placeholder: "e.g. 10" },
            { label: "Stroke Length (mm)", key: "strokeLength", placeholder: "e.g. 150" },
            { label: "Jack Type", key: "jackType", placeholder: "e.g. Bottle Jack" },
        ],
        "Crane": [
            { label: "Max Lifting Capacity (tons)", key: "maxLiftingCapacity", placeholder: "e.g. 20" },
            { label: "Boom Length (m)", key: "boomLength", placeholder: "e.g. 30" },
            { label: "Max Outreach (m)", key: "maxOutreach", placeholder: "e.g. 25" },
            { label: "Engine Power (HP)", key: "enginePower", placeholder: "e.g. 150" },
        ],
        "Excavator": [
            { label: "Operating Weight (tons)", key: "operatingWeight", placeholder: "e.g. 20" },
            { label: "Bucket Capacity (m³)", key: "bucketCapacity", placeholder: "e.g. 0.9" },
            { label: "Engine Power (HP)", key: "enginePower", placeholder: "e.g. 120" },
        ],
        "Bulldozer": [
            { label: "Engine Power (HP)", key: "enginePower", placeholder: "e.g. 150" },
            { label: "Blade Width (m)", key: "bladeWidth", placeholder: "e.g. 3.4" },
            { label: "Operating Weight (tons)", key: "operatingWeight", placeholder: "e.g. 17" },
        ],
        "Loader": [
            { label: "Bucket Capacity (m³)", key: "bucketCapacity", placeholder: "e.g. 2.5" },
            { label: "Engine Power (HP)", key: "enginePower", placeholder: "e.g. 120" },
            { label: "Operating Weight (tons)", key: "operatingWeight", placeholder: "e.g. 16" },
        ],
        "Dump Truck": [
            { label: "Load Capacity (tons)", key: "loadCapacity", placeholder: "e.g. 20" },
            { label: "Engine Power (HP)", key: "enginePower", placeholder: "e.g. 250" },
            { label: "Body Volume (m³)", key: "bodyVolume", placeholder: "e.g. 15" },
        ],
        "Concrete Mixer": [
            { label: "Drum Volume (m³)", key: "drumVolume", placeholder: "e.g. 0.8" },
            { label: "Engine Power (HP)", key: "enginePower", placeholder: "e.g. 25" },
        ],
        "Road Roller": [
            { label: "Operating Weight (tons)", key: "operatingWeight", placeholder: "e.g. 10" },
            { label: "Drum Width (mm)", key: "drumWidth", placeholder: "e.g. 2100" },
            { label: "Engine Power (HP)", key: "enginePower", placeholder: "e.g. 100" },
        ],
        "Tower Crane": [
            { label: "Max Load Capacity (tons)", key: "maxLoad", placeholder: "e.g. 10" },
            { label: "Jib Length (m)", key: "jibLength", placeholder: "e.g. 60" },
            { label: "Max Hook Height (m)", key: "hookHeight", placeholder: "e.g. 70" },
        ],
        "Pile Driver": [
            { label: "Hammer Weight (kg)", key: "hammerWeight", placeholder: "e.g. 2000" },
            { label: "Drop Height (m)", key: "dropHeight", placeholder: "e.g. 2.5" },
        ],
        "Grader": [
            { label: "Blade Length (m)", key: "bladeLength", placeholder: "e.g. 3.5" },
            { label: "Engine Power (HP)", key: "enginePower", placeholder: "e.g. 170" },
            { label: "Operating Weight (tons)", key: "operatingWeight", placeholder: "e.g. 16" },
        ],
        "Compactor": [
            { label: "Operating Weight (tons)", key: "operatingWeight", placeholder: "e.g. 3" },
            { label: "Plate Size (mm)", key: "plateSize", placeholder: "e.g. 500 x 600" },
            { label: "Engine Power (HP)", key: "enginePower", placeholder: "e.g. 8" },
        ],
        "Skid Steer Loader": [
            { label: "Operating Weight (tons)", key: "operatingWeight", placeholder: "e.g. 3" },
            { label: "Engine Power (HP)", key: "enginePower", placeholder: "e.g. 65" },
            { label: "Bucket Capacity (m³)", key: "bucketCapacity", placeholder: "e.g. 0.3" },
        ],
        "Concrete Pump": [
            { label: "Max Pumping Pressure (bar)", key: "pumpingPressure", placeholder: "e.g. 100" },
            { label: "Max Pumping Volume (m³/hr)", key: "pumpingVolume", placeholder: "e.g. 50" },
        ],
        "Forklift": [
            { label: "Load Capacity (tons)", key: "loadCapacity", placeholder: "e.g. 3" },
            { label: "Lift Height (m)", key: "liftHeight", placeholder: "e.g. 4.5" },
            { label: "Engine Type", key: "engineType", placeholder: "e.g. Diesel" },
        ],
        "Water Tanker": [
            { label: "Tank Volume (liters)", key: "tankVolume", placeholder: "e.g. 5000" },
            { label: "Engine Power (HP)", key: "enginePower", placeholder: "e.g. 130" },
            { label: "Chassis Type", key: "chassisType", placeholder: "e.g. TATA 709" },
        ],
        "Motor Grader": [
            { label: "Blade Length (m)", key: "bladeLength", placeholder: "e.g. 3.7" },
            { label: "Engine Power (HP)", key: "enginePower", placeholder: "e.g. 180" },
            { label: "Operating Weight (tons)", key: "operatingWeight", placeholder: "e.g. 17" },
        ],
        "Trencher": [
            { label: "Max Digging Depth (mm)", key: "diggingDepth", placeholder: "e.g. 1200" },
            { label: "Chain Width (mm)", key: "chainWidth", placeholder: "e.g. 300" },
            { label: "Engine Power (HP)", key: "enginePower", placeholder: "e.g. 75" },
        ]
    };

    useEffect(() => {
        const fetchUserDetails = async () => {
            const auth = getAuth()
            const user = auth.currentUser

            if (user) {
                const database = getDatabase()
                const userRef = dbRef(database, `profileDashboard/${user.uid}`)

                try {
                    const snapshot = await get(userRef)
                    if (snapshot.exists()) {
                        const userData = snapshot.val()
                        setCompanyName(userData.company_name || "")
                    } else {
                        console.error("No user data found in profileDashboard.")
                    }
                } catch (error) {
                    console.error("Error fetching user details:", error)
                }
            } else {
                setError("User is not authenticated")
            }
        }

        fetchUserDetails()
    }, [])

    useEffect(() => {
        const fetchUserId = async () => {
            const auth = getAuth()
            const user = auth.currentUser
            if (user) {
                setUserId(user.uid)
            } else {
                setError("User is not authenticated")
            }
        }
        fetchUserId()
    }, [])


    const handleFormSubmit = (event) => {
        event.preventDefault()
        setShowConfirmation(true)
    }

    const handleConfirmSubmit = async (event) => {
        event.preventDefault()
        setShowConfirmation(false)

        function getIndianTimestamp() {
            const now = new Date()
            const istOffset = 5.5 * 60 * 60 * 1000 // IST is UTC+5:30
            const istTime = new Date(now.getTime() + istOffset)
            return istTime.toISOString().replace("T", " ").replace("Z", "")
        }


        if (!product.name || product.name === "No brand selected") {
            setError("Please select a brand before submitting the form.")
            return
        }
        

        if (!userId) {
            setError("User is not authenticated")
            return
        }


        setLoading(true)
        try {

            const orderData = {
                brand: product.name || "",
                machinery: selectedMachinery,
                paymentOption: selectedPaymentOption,
                deliverydate: deliveryDate,
                siteAddress,
                timestamp: getIndianTimestamp(),
                status: "Pending",
                companyName,
                category: "machinery",
                condition: selectedCondition, // ✅ Add selected condition
                specifications: specs
            }

            // Write order to user's node
            const database = getDatabase()
            const userOrderRef = dbRef(database, `machineryOrder/${userId}`)
            const newOrderRef = push(userOrderRef)

            await dbSet(newOrderRef, orderData)
            const orderId = newOrderRef.key

            const sendNotification = async (userId, orderId, title, message) => {
                const notificationRef = dbRef(db, `supplier_notifications/Machinery Orders/${userId}/${orderId}`)
                const newNotification = {
                    brand: product.name || "",
                    title,
                    message,
                    gifUrl,
                    timestamp: getIndianTimestamp(),
                    seen: false,
                }

                try {
                    await set(notificationRef, newNotification)
                } catch (error) {
                    console.error("Error sending notification:", error)
                }
            }

            const notificationMessage = `A new machinery order has been placed by ${companyName} on this site ${siteAddress}. Please review the order details.`
            await sendNotification(userId, orderId, "New Machinery Order", notificationMessage)

            // Reset form
            setSiteAddress("")
            setSelectedMachinery("")
            setSelectedColour("")
            setSelectedPaymentOption("")
            setTechnicalSpecification("")
            setCompanyName("")
            setContactPersonName("")
            setContactEmail("")
            setContactPhoneNumber("")
            setDeliveryDate("")
            setError("")
            setSuccess(true)
        } catch (error) {
            setError("Error submitting order: " + error.message)
            console.error("Error submitting order:", error)
        } finally {
            setLoading(false)
            setUploadProgress({ po: 0, payment: 0 })
        }
    }

    const handleCancel = () => {
        setShowConfirmation(false)
    }

    const handleSiteAddressChange = (e) => {
        const inputText = e.target.value
    const wordCount = inputText.trim().split(/\s+/).filter(Boolean).length;

    if (wordCount <= 200) {
        setSiteAddress(inputText)
        setSiteAddressError("")
    } else {
        setSiteAddressError("Site Address cannot exceed 200 words.")
    }
    }
   

    const handleQuoteRequestClick = () => {
        navigate('/dashboard/quote-request');  // Navigate to the chat page
    };
    const handleMachineryChange = (e) => {
        const type = e.target.value;
        setSelectedMachinery(type);
        setSpecs({}); // Reset old specs if any
    };

    const isFormComplete =
        siteAddress &&
        companyName &&
        selectedCondition &&
        selectedPaymentOption &&
        deliveryDate &&
        selectedMachinery &&
        Object.values(specs).every((val) => val.trim() !== "");

    return (
        <div className="container-fluid machinery-container-fluid">
            <h1 className="machinery-page-title">Machinery Order</h1>

            <div className="machinery-product-detail-container">
                {/* Left Sidebar */}
                <div className="machinery-product-sidebar">
                    <img src={product.img || "/placeholder.svg"} alt={product.name} className="machinery-product-sidebar-image" />
                    <h2 className="machinery-product-sidebar-name">{product.name || "Machinery Product"}</h2>
                    <button type="button" className="machinery-quote-request-btn" onClick={handleQuoteRequestClick}>
                        Request a Quote
                    </button>
                </div>

                {/* Right Content */}
                <div className="machinery-product-content">
                    <form onSubmit={handleFormSubmit}>
                        <div className="machinery-order-form-group machinery-full-width">
                            <label htmlFor="siteAddress" className="machinery-form-label-static">Site Address</label>
                            <input
                                type="text"
                                id="siteAddress"
                                value={siteAddress}
                                onChange={handleSiteAddressChange}
                                required
                                placeholder=" "
                                className="machinery-product-form-input"
                                 minLength={10}
                                
                            />
                            {siteAddressError && <p className="machinery-error-message">{siteAddressError}</p>}
                             <p className="char-count">
    {siteAddress.trim().split(/\s+/).filter(Boolean).length} / 200 words
</p>

                        </div>

                        <div className="machinery-order-form-row">
                            <div className="machinery-order-form-group">
                                <label className="machinery-form-label-static">Company Name:</label>
                                <input
                                    type="text"
                                    value={companyName}
                                    onChange={(e) => setCompanyName(e.target.value)}
                                    required
                                    placeholder=" "
                                    className="machinery-product-form-input"
                                />
                            </div>
                        </div>

                        <div className="machinery-order-form-row two-columns">
                            <div className="machinery-order-form-group">
                                <label className="machinery-form-label-static">Payment Options:</label>
                                <select
                                    value={selectedPaymentOption}
                                    onChange={(e) => setSelectedPaymentOption(e.target.value)}
                                    required
                                    className="machinery-product-form-select"
                                >
                                    <option value="">Select Option</option>
                                    {paymentOptionList.map((paymentOption, index) => (
                                        <option key={index} value={paymentOption}>
                                            {paymentOption}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className="machinery-order-form-group">
                                <label className="machinery-form-label-static">Delivery Date:</label>
                                <input
                                    type="date"
                                    value={deliveryDate}
                                    onChange={(e) => setDeliveryDate(e.target.value)}
                                    required
                                    className="machinery-product-form-select"
                                />
                            </div>
                        </div>

                        <div className="machinery-order-form-row">
                            <div className="machinery-order-form-group">
                                <label className="machinery-form-label-static">Condition:</label>
                                <div className="machinery-radio-group">
                                    {["New", "Used", "Rent"].map((option) => (
                                        <label
                                            key={option}
                                            className={`machinery-radio-label ${selectedCondition === option ? "selected" : ""}`}
                                        >
                                            <input
                                                type="radio"
                                                name="condition"
                                                value={option}
                                                checked={selectedCondition === option}
                                                onChange={(e) => setSelectedCondition(e.target.value)}
                                                required
                                            />
                                            {option}
                                        </label>
                                    ))}
                                </div>

                            </div>
                        </div>

                        <div className="machinery-order-form-row two-columns">
                            <div className="machinery-order-form-group">
                                <label className="machinery-form-label-static">Technical Specification:</label>
                                <select className="machinery-product-form-select" onChange={handleMachineryChange} value={selectedMachinery}>
                                    <option value="">Select Machinery Type</option>
                                    {Object.keys(machinerySpecs).map((type) => (
                                        <option key={type} value={type}>{type}</option>
                                    ))}
                                </select>

                                {selectedMachinery && (
                                    <div className="machinery-spec-fields">
                                        {machinerySpecs[selectedMachinery].map(({ label, key, placeholder }) => (
                                            <div key={key} className="machinery-spec-input">
                                                <label>{label}</label>
                                                <input
                                                    type="text"
                                                    placeholder={placeholder}
                                                    value={specs[key] || ""}
                                                    onChange={(e) =>
                                                        setSpecs((prev) => ({ ...prev, [key]: e.target.value }))
                                                    }
                                                />
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                         </div>

                        <div className="machinery-action-buttons">
                            <button
                                type="submit"
                                className={`machinery-action-btn order-now ${isFormComplete ? "active" : ""}`}
                                disabled={!isFormComplete}
                            >
                                Order Now
                            </button>
                        </div>
                    </form>
                </div>
            </div>

            {/* Confirmation Modal */}
            {showConfirmation && (
                <div className="machinery-product-modal-overlay">
                    <div className="machinery-confirmation-modal">
                        <h3>Confirm Machinery Order</h3>
                        <p>Are you sure you want to place this Machinery order?</p>
                        <div className="machinery-modal-buttons">
                            <button onClick={handleConfirmSubmit} className="machinery-confirm-btn">
                                Yes, Place Order
                            </button>
                            <button onClick={handleCancel} className="machinery-cancel-btn">
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Success Modal */}
            {success && (
                <div className="machinery-product-modal-overlay">
                    <div className="machinery-product-success-modal">
                        <div className="machinery-success-icon">✓</div>
                        <h3>Machinery Order Submitted Successfully!</h3>
                        <button onClick={() => navigate("/dashboard")} className="machinery-close-btn">
                            Close
                        </button>

                    </div>
                </div>
            )}

            {/* Error Message */}
            {error && (
                <div className="machinery-error-notification">
                    <p>{error}</p>
                    <button onClick={() => setError("")} className="machinery-close-error-btn">×</button>
                </div>
            )}
        </div>
    );


}

export default MachineryOrderForm